import React, {useEffect, useState} from 'react';
import {MenuIcons} from "./style";
import Menu from "../Menu";
import {MenuWrapper} from "../Header/style";
import PropTypes from "prop-types";

const MenuIcon = ({toggleGeneralSettingsPopup}) => {
    const [menuList, setMenuList] = useState(false);

    const handleMenu = () => {
        setMenuList(!menuList);
    };

    const stopPropogation = (event) => {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
    };
    const handleOutsideClick = () => {
        setMenuList(false);

    };
    useEffect(() => {
        document.addEventListener("click", handleOutsideClick);
        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);

    useEffect(() => {
        handleOutsideClick();
    }, [window.location.pathname]);
    return (
        <MenuWrapper onClick={(e) => stopPropogation(e)}>
            <MenuIcons onClick={handleMenu} isActive={menuList}/>
            {menuList && <Menu toggleGeneralSettingsPopup={toggleGeneralSettingsPopup} isActive={menuList}/>}
        </MenuWrapper>
    );
};
MenuIcon.propTypes = {
    toggleGeneralSettingsPopup: PropTypes.func.isRequired
};

export default MenuIcon;